import { TitleComponent } from "../ui/TitleComponent";
import { FullScreenModal } from "../ui/FullScreenModal";
import { GasSimSelector } from "./simulators/gas/GasSimSelector";
import { useContext, useState } from "react";
import DataContext from "../../context/DataContext";
import SimulatorContext from "../../context/SimulatorContext";
import { SandSimSelector } from "./simulators/sand/SandSimSelector";
import { PressureSimSelector } from "./simulators/pressure/PressureSimSelector";
import {
  initial_gas_simulator_state,
  initial_gas_simulator_results,
  initial_sand_simulator_state,
  initial_sand_simulator_results,
  initial_press_simulator_state,
  initial_press_simulator_results,
  initial_pmm_guardian_simulator_state,
  initial_pmm_guardian_simulator_results,
} from "../../utils/data";
import styles from "../components.module.sass";

export const SolutionComponent = () => {
  const [activeSandTab, setActiveSandTab] = useState(0);

  const {
    onUpdateSolution,
    data: {
      solution: { sandSolution, gasSolution, pressureSolution, pmmGuardianSolution },
    },
  } = useContext(DataContext);
  const {
    gasSimulatorValues,
    vortexSimulatorValues,
    gasSimulatorResults,
    sandSimulatorValues,
    sandSimulatorResults,
    pmmGuardianValues,
    pmmGuardianResults,
    pressSimulatorValues,
    pressSimulatorResults,
    simulatorState,
  } = useContext(SimulatorContext);

  const handleSaveGasSimulation = () => {
    if (simulatorState.gas.vortex) {
      onUpdateSolution(
        "gasSolution",
        true,
        {
          data: vortexSimulatorValues,
          results: null,
        },
        simulatorState,
      );
    } else {
      onUpdateSolution(
        "gasSolution",
        true,
        {
          data: gasSimulatorValues,
          results: gasSimulatorResults,
        },
        simulatorState,
      );
    }
  };

  const handleRemoveGasSimulation = () => {
    onUpdateSolution(
      "gasSolution",
      false,
      {
        data: initial_gas_simulator_state,
        results: initial_gas_simulator_results,
      },
      simulatorState,
    );
  };

  const handleSaveSandSimulation = () => {
    if (activeSandTab === 3) {
      onUpdateSolution(
        "pmmGuardianSolution",
        true,
        {
          data: pmmGuardianValues,
          results: pmmGuardianResults,
        },
        simulatorState,
      );
    } else {
      onUpdateSolution(
        "sandSolution",
        true,
        {
          data: sandSimulatorValues,
          results: sandSimulatorResults,
        },
        simulatorState,
      );
    }
  };

  const handleRemoveSandSimulation = () => {
    if (activeSandTab === 3) {
      onUpdateSolution(
        "pmmGuardianSolution",
        false,
        {
          data: initial_pmm_guardian_simulator_state,
          results: initial_pmm_guardian_simulator_results,
        },
        simulatorState,
      );
    } else {
      onUpdateSolution(
        "sandSolution",
        false,
        {
          data: initial_sand_simulator_state,
          results: initial_sand_simulator_results,
        },
        simulatorState,
      );
    }
  };

  const handleSavePressureSimulation = () => {
    onUpdateSolution(
      "pressureSolution",
      true,
      {
        data: pressSimulatorValues,
        results: pressSimulatorResults,
      },
      simulatorState,
    );
  };

  const handleRemovePressureSimulation = () => {
    onUpdateSolution(
      "pressureSolution",
      false,
      {
        data: initial_press_simulator_state,
        results: initial_press_simulator_results,
      },
      simulatorState,
    );
  };

  return (
    <>
      <div className={styles.solutionForm}>
        <FullScreenModal
          title="Gas Simulator"
          onSave={handleSaveGasSimulation}
          onRemove={handleRemoveGasSimulation}
          active={gasSolution}
        >
          <GasSimSelector />
        </FullScreenModal>
        <FullScreenModal
          title="Sand Simulator"
          onSave={handleSaveSandSimulation}
          onRemove={handleRemoveSandSimulation}
          active={sandSolution || pmmGuardianSolution}
        >
          <SandSimSelector onTabChange={setActiveSandTab} />
        </FullScreenModal>
        <FullScreenModal
          title="Pressure Drop Simulator"
          onSave={handleSavePressureSimulation}
          onRemove={handleRemovePressureSimulation}
          active={pressureSolution}
        >
          <PressureSimSelector />
        </FullScreenModal>
      </div>
    </>
  );
};
